import React, { useState } from "react";
import { Box, Grid, TextField, Typography, Button, Modal } from "@mui/material";
import upload2 from "../../assets/img/upload2.png";
import { updateProduct } from "../../api/Api";
import cross from "../../assets/img/cross.png";
import { useTheme } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};

const UpdateModal = ({ open, handleClose, initialData, onSubmit }) => {
  const theme = useTheme();
  const [itemName, setItemName] = useState(initialData.name || "");
  const [brandName, setBrandName] = useState(initialData.brand || "");
  const [itemPrice, setItemPrice] = useState(initialData.price || "");
  const [itemQuantity, setItemQuantity] = useState(initialData.stock || "");
  const [itemDetails, setItemDetails] = useState(initialData.description || "");
  const [productCode, setProductCode] = useState(
    initialData.productCode || null
  );
  const [imagePreview, setImagePreview] = useState(
    initialData.images?.[0] || ""
  );
  const [uploadedImage, setUploadedImage] = useState(null);

  const [loading, setLoading] = useState(false); // Track loading state
  // const [successModalOpen, setSuccessModalOpen] = useState(false); // Track success modal state

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Set loading to true

    const updatedData = {
      productCode,
      name: itemName,
      brand: brandName,
      price: itemPrice,
      stock: itemQuantity,
      description: itemDetails,
      // images: uploadedImage ? [URL.createObjectURL(uploadedImage)] : initialData.images,
    };

    try {
      await updateProduct(updatedData); // Call the API to update the product
      onSubmit(updatedData);
      // setSuccessModalOpen(true); // Open success modal on success

      // Close the success modal after 2 seconds
      setTimeout(() => {
        // setSuccessModalOpen(false);
        handleClose(); // Close the main modal
      }, 2000);
    } catch (error) {
      console.error("Failed to update product:", error);
    } finally {
      setLoading(false); // Set loading back to false
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="update-item-modal-title"
      aria-describedby="update-item-modal-description"
    >
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "20px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", // Aligns title and cross icon
          }}
        >
          <Typography id="update-item-modal-title" variant="h6" component="h2">
            Update Item Details
          </Typography>
          <Box
            component="img"
            src={cross}
            alt="Close"
            sx={{
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
            onClick={handleClose} // Closes the modal when clicked
          />
        </Box>
        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Item Name"
                    value={itemName}
                    onChange={(e) => setItemName(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Brand Name"
                    value={brandName}
                    onChange={(e) => setBrandName(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Item Price"
                    value={itemPrice}
                    onChange={(e) => setItemPrice(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Item Available Quantity"
                    value={itemQuantity}
                    onChange={(e) => setItemQuantity(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Item Details"
                    value={itemDetails}
                    onChange={(e) => setItemDetails(e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                direction="column"
                alignItems="flex-end"
                spacing={4}
                sx={{
                  padding: "1vw",
                }}
              >
                <Grid item container justifyContent="space-between">
                  <Grid item xs={6}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Upload Item Photo
                    </Typography>
                    <Button
                      variant="contained"
                      component="label"
                      disabled
                      sx={{
                        width: "150px",
                        height: "140px",
                        padding: "16px",
                        border: "1px dashed #CCCCCC",
                        backgroundColor: "#F5F5F5",
                        borderRadius: "15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "#000",
                        "&:hover": {
                          backgroundColor: "#E0E0E0",
                        },
                      }}
                    >
                      <img
                        src={upload2}
                        alt=""
                        style={{
                          height: "35px",
                          width: "35px",
                          padding: "5px",
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#000",
                          textAlign: "center",
                          fontSize: "15px",
                          textTransform: "capitalize",
                        }}
                      >
                        Upload Photo
                      </Typography>
                      <input
                        type="file"
                        hidden
                        disabled
                        onChange={handleImageUpload}
                      />{" "}
                      {/* Disables input */}
                    </Button>

                    <Typography
                      sx={{
                        color: "#FF1744",
                        mt: 1,
                        textAlign: "left",
                        fontSize: "13px",
                        width: "20vw",
                      }}
                    >
                      Image must be in .png, .jpg format and max width of 1080px
                    </Typography>
                  </Grid>
                  
                  <Grid item xs={6}>
                    {imagePreview && (
                      <Box
                        component="img"
                        sx={{
                          width: "150px",
                          height: "140px",
                          objectFit: "cover",
                          borderRadius: "15px",
                          border: "1px solid #CCCCCC",
                        }}
                        src={imagePreview}
                        alt="Item Preview"
                      />
                    )}
                  </Grid>
                </Grid>

                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "1rem",
                    width: "10vw",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading} // Disable button when loading
                    sx={{
                      width: "100%",
                      height: "100%",
                      padding: "10px",
                      backgroundColor:theme.palette.primary.light,
                      textTransform: "capitalize",
                    }}
                  >
                    {loading ? "Please wait..." : "Update Data"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* <SuccessModal open={successModalOpen} onClose={() => setSuccessModalOpen(false)} /> */}
    </Modal>
  );
};

export default UpdateModal;
